// extracted by mini-css-extract-plugin
export default {"devSkill":"Skills_devSkill__vZxGs"};